import { Routes } from '@angular/router';
import {MainComponent} from "./main/main.component";
import {Login} from "./features/login/login";
import {LoginTest} from "./features/login-test/login-test";
import {Register} from "./features/register/register";
import {ResetPassword} from "./features/reset-password/reset-password";
import {AdminUsers} from "./features/admin-users/admin-users";
import {AuthLogs} from "./features/auth-logs/auth-logs";
import {AdminSecurityPolicy} from "./features/admin-security-policy/admin-security-policy";
import {PrivacyPolicy} from "./features/privacy-policy/privacy-policy";
import {AccountPrivacyPolicy} from "./features/account/account-privacy-policy";
import {adminGuard, authGuard, guestGuard, superAdminGuard} from "./core/guards/auth.guards";
import {environment} from "../environments/environment";

const loginRoutes: Routes = environment.production
  ? [
      { path: 'login', component: Login, canActivate: [guestGuard] },
    ]
  : [
      { path: 'login', component: LoginTest, canActivate: [guestGuard] },
      { path: 'login-test', component: Login, canActivate: [guestGuard] },
    ];

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'main' },
  ...loginRoutes,
  { path: 'register', component: Register, canActivate: [guestGuard] },
  { path: 'reset-password', component: ResetPassword },
  { path: 'privacy-policy', component: PrivacyPolicy },
  { path: 'account/privacy-policy', component: AccountPrivacyPolicy, canActivate: [authGuard] },
  { path: 'main', component: MainComponent, canActivate: [authGuard] },
  { path: 'admin/users', component: AdminUsers, canActivate: [adminGuard] },
  { path: 'admin/auth-logs', component: AuthLogs, canActivate: [superAdminGuard], data: { admin: true } },
  { path: 'admin/security-policy', component: AdminSecurityPolicy, canActivate: [superAdminGuard] },
  { path: 'auth-logs', component: AuthLogs, canActivate: [authGuard] },
];
